/* tslint:disable */
/* eslint-disable */
/* @relayHash 57252f597fd7021daf6350e7b3a878fe */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQueryVariables = {
    itemIds: Array<string | null>;
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQueryResponse = {
    readonly viewer: {
        readonly itemRead: ReadonlyArray<{
            readonly isPrivateVisibilityType?: boolean | null;
            readonly status?: string | null;
            readonly pricing?: {
                readonly bargain: boolean | null;
            } | null;
        } | null> | null;
    };
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery = {
    readonly response: pdpSharedNotificationMultiplePdpVisitsModalConfigQueryResponse;
    readonly variables: pdpSharedNotificationMultiplePdpVisitsModalConfigQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v2 = {
  "kind": "InlineFragment",
  "type": "Item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isPrivateVisibilityType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "bargain",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemRead",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemRead",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "id": "app-buyer-finding/257.0.0-2020-03-26T15:41:46.002Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '65c36a50087ae7f9205d2ecece186a37';
export default node;
